import React, { useState } from "react";
import PageContainer from "../custom/Page";
import HeaderPageItem from "../custom/HeaderPageItem";
import FixedPageItem from "../custom/FixedPageItem";
import { Tab, Tabs } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import CustomersContent from "./components/Management/CustomersContent";
import SummaryAgentContent from "./components/Management/SummaryAgentContent";
import { useEffect } from "react";
import ReportsMenu from "./components/ReportsMenu";
import { withRouter } from "react-router-dom";
import InvitesContent from "./components/Management/InvitesContent";

const validTabs = ["summary", "invites", "customers", "reports"];

const CustomerManagement = ({ match, history }) => {
  const tabParam = match?.params?.tab;

  const initialTab = tabParam && validTabs.includes(tabParam) ? tabParam : "summary";
  const [tabName, setTabName] = useState(initialTab);

  const indexContent = {
    summary: <SummaryAgentContent />,
    invites: <InvitesContent />,
    customers: <CustomersContent />,
    reports: (
      <ReportsMenu enableContractsByCustomer enableContractsDirectBelow />
    ),
  };

  useEffect(() => {
    if (tabParam && tabParam !== tabName && validTabs.includes(tabParam)) {
      setTabName(tabParam);
    }
  }, [tabParam, tabName]);

  const handleTabChange = (event, newTabName) => {
    if (validTabs.includes(newTabName)) {
      setTabName(newTabName);
      history.push(`/customer-management/${newTabName}`);
    }
  };

  return (
    <PageContainer>
      <HeaderPageItem title="app.customer.management" />
      <FixedPageItem position="top" height={50}>
        <Tabs variant="fullWidth" indicatorColor="primary" textColor="primary" value={tabName} onChange={handleTabChange}>
          <Tab value="summary" label={<FormattedMessage id="app.resume" />} />
          <Tab value="invites" label={<FormattedMessage id="app.invites" />} />
          <Tab value="customers" label={<FormattedMessage id="app.customers" />} />
          <Tab value="reports" label={<FormattedMessage id="app.reports" />} />
        </Tabs>
      </FixedPageItem>
      {indexContent[tabName]}
    </PageContainer>
  );
};

export default withRouter(CustomerManagement);
